import { Directive, Input, HostBinding, HostListener, OnInit, inject } from '@angular/core';
import { config, MemberQuery } from '@fgb/core';
import { buildContentAssetUrl } from '../utils/content-asset-url.util';

/**
 * Enables a default image source to be specified that will be shown upon image retrieval error (i.e. HTTP 404).
 * Usage:
 *  <img src="https://www.normal-image-address.com/image.jpg" useDefault="true"></img>
 */
@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'img[useDefault]',
})
export class ImgDefaultDirective implements OnInit {
  @HostBinding('attr.src') @Input() src: string;
  @Input() useDefault: boolean;
  @Input() loyaltyType: 'marketplace' | 'auction' | 'lotto' | 'wallet' | 'walletRedeemed' | 'badge';
  @HostBinding('class.image-loaded') imageLoaded = false;
  @HostBinding('class.image-error') imageError = false;
  DefaultImgSrc: string;
  private memberQuery = inject(MemberQuery);

  constructor() {}

  ngOnInit() {
    if (!this.loyaltyType) {
      this.DefaultImgSrc = `${config.contentUrl}/noimage.png`;
    } else {
      switch (this.loyaltyType) {
        case 'marketplace': {
          this.DefaultImgSrc = buildContentAssetUrl(this.memberQuery, 'placeholders/marketplace-item.png');
          break;
        }
        case 'auction': {
          this.DefaultImgSrc = buildContentAssetUrl(this.memberQuery, 'placeholders/auction-item.png');
          break;
        }
        case 'lotto': {
          this.DefaultImgSrc = buildContentAssetUrl(this.memberQuery, 'placeholders/lotto-item.png');
          break;
        }
        case 'wallet': {
          this.DefaultImgSrc = buildContentAssetUrl(this.memberQuery, 'placeholders/marketplace-item.png');
          break;
        }
        case 'badge': {
          this.DefaultImgSrc = buildContentAssetUrl(this.memberQuery, 'placeholders/badge-item.png');
          break;
        }
        default: {
          this.DefaultImgSrc = buildContentAssetUrl(this.memberQuery, 'placeholders/marketplace-item.png');
          break;
        }
      }
    }
  }

  /**
   * Called on error. Sets the default image source if required and the class to 'image-error'.
   */
  @HostListener('error') updateUrl() {
    if (this.useDefault) {
      this.src = this.DefaultImgSrc;
    }
    this.imageError = true;
  }

  /**
   * Called on success. Leaves the requested image source as-is and sets the class to 'image-loaded'.
   */
  @HostListener('load') load() {
    this.imageLoaded = true;
  }
}
